module.exports = __webpack_public_path__ + "img/shouqiang.60a993c0.png";